import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/index.css";
import { AuthProvider, useAuth } from "@/auth/AuthContext";
import Header from "@/components/Header";
import AuthModal from "@/components/AuthModal";
import Landing from "@/pages/Landing";
import Sorteio from "@/pages/Sorteio";
import Payment from "@/pages/Payment";
import Premios from "@/pages/Premios";
import MinhaConta from "@/pages/MinhaConta";
import Painel from "@/pages/Painel";

// Admin não joga como utilizador normal — só tem /admin disponível,
// qualquer outra rota redireciona para lá automaticamente.
function AppRouter() {
  const { user, modalOpen, closeModal } = useAuth();
  const { pathname } = useLocation();
  const isolated = pathname === "/admin";
  const adminLocked = user?.is_admin && pathname !== "/admin";

  if (adminLocked) return <Navigate to="/admin" replace />;

  return (
    <>
      {!isolated && <Header />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/sorteio" element={<Sorteio />} />
        <Route path="/pagamento/:orderId" element={<Payment />} />
        <Route path="/premios" element={<Premios />} />
        <Route path="/minha-conta" element={<MinhaConta />} />
        <Route path="/admin" element={<Painel />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      {!isolated && <AuthModal open={modalOpen} onClose={closeModal} />}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster theme="dark" position="top-center" toastOptions={{
          style: { background: "#131C15", border: "1px solid rgba(212,175,55,0.2)", color: "#F1E8D9" }
        }} />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
